import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-arrow-resize-3",
  "use": "icon-si-glyph-arrow-resize-3-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-arrow-resize-3\" id=\"icon-si-glyph-arrow-resize-3\">\n    <!-- Generator: Sketch 3.0.3 (7891) - http://www.bohemiancoding.com/sketch -->\n    <title>125</title>\n    \n    <defs></defs>\n    <g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <g fill=\"#434343\">\n            <path d=\"M15.995,1.852 L14.133,0.00800000003 L11.107,2.988 L9.062,0.972 L9.062,6.875 L15.049,6.875 L12.973,4.828 L15.995,1.852 Z\" class=\"si-glyph-fill\" />\n            <path d=\"M0.961,9.008 L3.058,11.095 L0.005,14.128 L1.885,16.008 L4.942,12.97 L6.909,14.966 L6.909,9.008 L0.961,9.008 Z\" class=\"si-glyph-fill\" />\n        </g>\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-arrow-resize-3.svg
// module id = QLAa
// module chunks = 62